
import { ITreeViewPhongThiFocusedValue } from "../../../components-data/treeview-phong-thi/TreeViewPhongThi";
import { ThiSinhGenerateSBDRequest } from "../../../model/request/tct/IDanhSoBaoDanhRequest";
import { IThiSinh } from "../../../model/respone/tct/IThiSinh";
import { IThiSinhVm } from "../../../model/respone/tct/IThiSinhVm";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IThiSinhActionTypeBase<T> {
    phongThiId: number,
    data: T
}
export const eThiSinhActionsObj = {
    CHANGE_DOT_THI_ID: {} as IThiSinhActionTypeBase<number>,
    CHANGE_PHONG_THI_ID: {} as IThiSinhActionTypeBase<undefined>,
    CHANGE_FOCUSED_TREEVIEW_NODE: {} as IThiSinhActionTypeBase<ITreeViewPhongThiFocusedValue>,

    LOAD_START: {} as IThiSinhActionTypeBase<undefined>,
    LOAD_SUCCESS: {} as IThiSinhActionTypeBase<IThiSinhVm[]>,
    LOAD_ERROR: {} as IThiSinhActionTypeBase<string>,

    SHOW_EDIT_MODAL: {} as IThiSinhActionTypeBase<IThiSinhVm | undefined>,
    CLOSE_EDIT_MODAL: {} as IThiSinhActionTypeBase<undefined>,

    SAVE_START: {} as IThiSinhActionTypeBase<IThiSinh>,
    SAVE_SUCCESS: {} as IThiSinhActionTypeBase<IThiSinh>,
    SAVE_ERROR: {} as IThiSinhActionTypeBase<string>,

    DELETE_START: {} as IThiSinhActionTypeBase<number[]>,
    DELETE_SUCCESS: {} as IThiSinhActionTypeBase<number[]>,
    DELETE_ERROR: {} as IThiSinhActionTypeBase<string>,

    UPDATES_START: {} as IThiSinhActionTypeBase<IThiSinh[]>,
    UPDATES_SUCCESS: {} as IThiSinhActionTypeBase<IThiSinh[]>,
    UPDATES_ERROR: {} as IThiSinhActionTypeBase<string>,

    INSERTS_START: {} as IThiSinhActionTypeBase<IThiSinh[]>,
    INSERTS_SUCCESS: {} as IThiSinhActionTypeBase<IThiSinh[]>,
    INSERTS_ERROR: {} as IThiSinhActionTypeBase<string>,

    CHANGE_SELCTED_IDS: {} as IThiSinhActionTypeBase<number[]>,

    SHOW_ADD_THI_SINH_MODAL: {} as IThiSinhActionTypeBase<undefined>,
    CLOSE_ADD_THI_SINH_MODAL: {} as IThiSinhActionTypeBase<undefined>,

    SHOW_SBD_MODAL: {} as IThiSinhActionTypeBase<undefined>,
    CLOSE_SBD_MODAL: {} as IThiSinhActionTypeBase<undefined>,

    GENERATE_SBD_START: {} as IThiSinhActionTypeBase<ThiSinhGenerateSBDRequest>,
    GENERATE_SBD_SUCCESS: {} as IThiSinhActionTypeBase<ThiSinhGenerateSBDRequest>,
    GENERATE_SBD_ERROR: {} as IThiSinhActionTypeBase<string>,

    LOAD_ALL_START: {} as IThiSinhActionTypeBase<number>,
    LOAD_ALL_SUCCESS: {} as IThiSinhActionTypeBase<IThiSinhVm[]>,
    LOAD_ALL_ERROR: {} as IThiSinhActionTypeBase<string>,
};
export const eThiSinhActionIds = generateActionTypeIds(
    eThiSinhActionsObj,
    "THI_SINH"
);
export type IThiSinhActionTypes = IGenericActionType<
    typeof eThiSinhActionsObj,
    "THI_SINH"
>;
